import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';

import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/plugins/analytics';
import '@/plugins/font-awesome';
import '@/plugins/sentry';
import '@/plugins/vee-validate';

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
